import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Avatar,
  Box,
  Modal,
  Typography,
  IconButton,
  TextField,
  Button,
  useMediaQuery,
  Stack,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import ShareIcon from "@mui/icons-material/Share";
import logo from "../../assets/images/bf.jpg";
import CustomPopover from "./CustomPopOver";
import { EmojiEmotions, MoreVertOutlined } from "@mui/icons-material";
import { Icon } from "@iconify/react";
import CustomConfirmation from "./CustomConfirmation";
import { enqueueSnackbar, useSnackbar } from "notistack";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ImageGallery from "react-image-gallery";
import EmojiPicker from "emoji-picker-react";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import moment from "moment";
import {
  handle_get_time_ago,
  htmlDecode,
  is_small_screen,
} from "../../utils/Constant";
import ReactVideoPlayer from "../player/ReactVideoPlayer";
import { useIds } from "../../hook/AdminContext";
import { s3baseUri } from "../../config/config";
import FeedImageSlider from "../cards/FeedImageSlider";
import {
  csvImage,
  docImage,
  pdfImage,
  wordImage,
  audioImage,
  xlsxImage,
  otherImage,
  liked_icon,
  like_icon,
  comment_icon,
  share_icon,
  liked_counts_icon,
} from "../../assets";
import PreviewPostCard from "../previewUrl/LinkPreviewPostCard";
import { useNavigate } from "react-router-dom";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import Divider from "@mui/material/Divider";
import RecordNoImage from "../recordNotFound/RecordNoImage";
import { detail_feed_api } from "../../DAL/feed/feed";
import CompanyPopup from "./CompanyPopup";
import { LikedIcon } from "../../assets/icon/LikedIcon";
import LikeIcon from "../../assets/icon/LikeIcon";
import CommentIcon from "../../assets/icon/CommentIcon";
import { linkify } from "../../utils/ConverHtml";
import ActionByChip from "../cards/ActionByChip";

const PostDetailPopup = ({
  parseDescriptionWithLink,
  linkInDescription,
  setLiked,
  likedComment,
  handleLikeComment,
  open,
  handleMenu,
  handleLike,
  liked,
  onClose,
  post,
  comments,
  likeCount,
  handleMenucomments,
  isLoadingCom,
  setEmojiPickerVisible,
  emojiPickerVisible,
  setComment,
  setComments,
  comment,
  handleEmojiClick,
  handleImageUpload,
  setPreview,
  preview,
  commentText,
  setCommentText,
  handleCommentSubmit,
  setIsEditing,
  handleCancelEditComment,
  isEditing,
  selectedImageIndex,
  commentCount,
  setCommentCount,
  commentsLikeCount,
  setCommentsLikeCount,
  setLikedComment,
  handleShareClick,
  setExpanded,
  expanded,
  linkedDescription,
  parseDescriptionWithFormatting,
  setShowReadMore,
  showReadMore,
  isCommentAccessAllow,
  isCommentUpdateAllow,
  previewLink,
  setPreviewLink,
  type,
  handleUpdateSpecificFeed = () => {},
}) => {
  const navigate = useNavigate();
  const { userInfo, handleGetActionByStatus } = useIds();
  const { enqueueSnackbar } = useSnackbar();

  const [commentsData, setCommentsData] = useState(comments);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [commentDialogue, setCommentDialogue] = useState(false);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [totlePages, setTotlePages] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [loadMorePath, setLoadMorePath] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [slides, setSlides] = useState([]);
  const [loadMore, setLoadMore] = useState("api/feed/detail?page=1&limit=50");
  // const [showReadMore, setShowReadMore] = useState(false);
  const textRef = React.useRef(null);
  const observer = useRef();

  const measureRef = useRef(null);
  const [clampedText, setClampedText] = useState("");
  const [needsClamp, setNeedsClamp] = useState(false);

  const text = post?.description || "";

  console.log(text, "--text");
  console.log(clampedText, "clampedText");
  console.log(expanded, "expanded");

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totlePages > pageNumber) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totlePages, pageNumber, loadMorePath, observer]
  );

  const getFeedsDeteil = async () => {
    const result = await detail_feed_api(post._id);
    if (result.code === 200) {
      handleUpdateSpecificFeed(result.feed);
      setCommentCount(result.total_comments);
      setLoadMorePath(result?.load_morse);
      setComments(result.feed_comment);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const isMobile = useMediaQuery("(max-width:600px)");
  const [companyModalOpen, setCompanyModalOpen] = useState(false);
  const [companyModalData, setCompanyModalData] = useState(null);
  const handleCompanyNameClick = () => {
    // setCompanyModalData(post?.created_by);
    // setCompanyModalOpen(true);
    navigate("/user/" + post?.created_by?._id);
  };
  const handleCommentCompanyClick = (user) => {
    setCompanyModalData(user.commented_by);
    setCompanyModalOpen(true);
  };
  const handleCloseCompanyModal = () => {
    setCompanyModalOpen(false);
    setCompanyModalData(null);
  };
  const hadnlecommentdialogueOpen = () => {
    setCommentDialogue(true);
  };
  const handleCommentDelete = () => {
    setCommentDialogue(false);
    enqueueSnackbar("comment deleted successfully.", { variant: "success" });
  };
  const formatText = (text) => {
    if (!text) return "";

    text = text.replace(/(\S{10,})/g, "$1\u200B");

    const words = text.split(" ");
    return words
      .reduce((acc, word, index) => {
        if (index % 25 === 0 && index !== 0) {
          acc += "<br/>";
        }
        return acc + word + " ";
      }, "")
      .trim();
  };
  const loadMoreData = () => {
    setLoadMore(loadMorePath);
    setIsLoadingMore(true);
  };

  const handleDialogueOpen = () => {
    setLogoutDialogOpen(true);
  };

  const handleFeedEdit = () => {
    setOpenCreateModal(true);
  };

  const handleLogout = () => {
    setLogoutDialogOpen(false);
    enqueueSnackbar("post deleted successfully.", { variant: "success" });
  };

  const MENU_OPTIONS = [
    {
      label: "Edit",
      icon: "akar-icons:edit",
    },
    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: handleDialogueOpen,
    },
  ];
  const handleEditComment = (comment, index) => {
    setIsEditing(true);
    setCommentText(comment.text);
  };
  const imageLinks = {
    docx: wordImage,
    mp3: audioImage,
    pdf: pdfImage,
    csv: csvImage,
    doc: docImage,
    xlsx: xlsxImage,
    xls: xlsxImage,
    other: otherImage,
  };

  const getCommentImage = (file) => {
    if (file.type === "file") {
      const ext = file.path.name.split(".").pop();
      if (
        ext == "jpg" ||
        ext == "JPG" ||
        ext == "png" ||
        ext == "webp" ||
        ext == "jpeg" ||
        ext == "JPEG" ||
        ext == "PNG"
      ) {
        return URL.createObjectURL(file.path);
      } else if (imageLinks[ext]) {
        return imageLinks[ext];
      } else {
        return imageLinks.other;
      }
    } else {
      const ext = file.split(".").pop();
      if (
        ext == "jpg" ||
        ext == "JPG" ||
        ext == "png" ||
        ext == "webp" ||
        ext == "jpeg" ||
        ext == "JPEG" ||
        ext == "PNG"
      ) {
        return s3baseUri + file;
      } else if (imageLinks[ext]) {
        return imageLinks[ext];
      } else {
        return imageLinks.other;
      }
    }
  };

  const handleTextClamp = () => {
    const el = measureRef.current;
    if (!el) return;

    const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
    const maxHeight = lineHeight * 3; // Maximum height for 3 lines

    // Step 1: Set full text to measure total height
    el.innerText = text;
    const fullHeight = el.scrollHeight;

    // If text fits in <= 3 lines → no "view more"
    if (fullHeight <= maxHeight) {
      setNeedsClamp(false);
      setClampedText(text);
      return;
    }

    // Otherwise, we need to clamp the text
    setNeedsClamp(true);

    // ---- Binary search to find best fitting cutoff ----
    let low = 0;
    let high = text.length;
    let bestFit = text;

    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      el.innerText = text.slice(0, mid);

      if (el.scrollHeight <= maxHeight) {
        bestFit = text.slice(0, mid);
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    // Remove partial last word
    bestFit = bestFit.replace(/\s+\S*$/, "");

    setClampedText(bestFit);
  };

  useEffect(() => {
    let slide = [];
    if (post.feed_type == "image" && post?.media?.length > 0) {
      slide = post.media.map((item) => {
        return {
          original: s3baseUri + item.thumbnail_1,
          thumbnail: s3baseUri + item.thumbnail_1,
        };
      });
    }
    setSlides(slide);
  }, [post]);

  useEffect(() => {
    if (post && post.socket_comment) {
      setComments((prev) => {
        // Filter out the existing comment if it exists
        const filteredComments = prev.filter(
          (comment) => comment._id !== post.socket_comment._id
        );
        // Add the updated/new comment at the top
        return [post.socket_comment, ...filteredComments];
      });
    }
    if (post && post.deleted_comment_id) {
      setComments((prev) =>
        prev.filter((obj) => obj._id !== post.deleted_comment_id)
      );
    }
    if (post && post.update_comment) {
      setComments((prev) =>
        prev.map((obj) =>
          obj._id == post.update_comment._id ? { ...post.update_comment } : obj
        )
      );
    }
  }, [post]);

  useEffect(() => {
    if (open) {
      getFeedsDeteil();
      setTimeout(() => {
        handleTextClamp();
      }, 10);
    }
  }, [open]);

  useEffect(() => {
    if (comments?.liked_by?.length > 0) {
      const isLiked = comments.liked_by?.some(
        (user) => user._id === userInfo?._id
      );
      setLiked(isLiked);
    }
    if (comments.length > 0) {
      const likedComments = comments.reduce((acc, item, index) => {
        acc[index] = item.liked_by?.some((user) => user._id === userInfo?._id);
        return acc;
      }, {});

      const likedCounts = comments.reduce((acc, item, index) => {
        acc[index] = item.liked_by?.length;
        return acc;
      }, {});

      setCommentsLikeCount(likedCounts);
      setLikedComment(likedComments);
    }
  }, [comments]);

  // Check if text content exceeds 3 lines
  useEffect(() => {
    if (textRef.current && post?.description) {
      const element = textRef.current;
      const lineHeight = parseInt(window.getComputedStyle(element).lineHeight);
      const height = element.scrollHeight;
      const lines = Math.round(height / lineHeight);
      setShowReadMore(lines > 3);
    }
  }, [post?.description]);

  const getImages = (data) => {
    let galleryArray = [];
    let galleryObject = {};
    data.map((gallery, index) => {
      galleryObject = {
        original: s3baseUri + gallery.thumbnail_1,
        thumbnail: s3baseUri + gallery.thumbnail_1,
      };
      galleryArray.push(galleryObject);
    });
    return galleryArray;
  };

  useEffect(() => {
    // Facebook SDK load karein
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "724262789278150",
        cookie: true,
        xfbml: true,
        version: "v18.0",
      });
    };

    // SDK script load
    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    document.head.appendChild(script);
  }, []);

  // const sharePopoverOpen = Boolean(shareAnchorEl);

  return (
    <>
      <CustomConfirmation
        open={logoutDialogOpen}
        setOpen={setLogoutDialogOpen}
        title={"Are you sure you want to delete this post?"}
        handleAgree={handleLogout}
      />
      <CustomConfirmation
        open={commentDialogue}
        setOpen={setCommentDialogue}
        title={"Are you sure you want to delete this comment?"}
        handleAgree={handleCommentDelete}
      />
      <Modal open={open} onClose={onClose} sx={{ overflow: "auto" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "100vw",
            height: "100vh",
            bgcolor: "black",
            overflow: "auto !important",
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 10,
              left: 10,
              padding: "4px",
              backgroundColor: "white",
              zIndex: 10,
              "&:hover": {
                backgroundColor: "white",
              },
            }}
          >
            <CloseIcon style={{ fontSize: "18px" }} />
          </IconButton>

          {post?.feed_type === "image" && post.media ? (
            <div className="w-100 post-detail-image">
              <FeedImageSlider
                data={getImages(post.media)}
                selectedIndex={selectedImageIndex}
              />
            </div>
          ) : (
            ""
          )}
          {post?.feed_type === "video" && post?.video_url && (
            <Box
              sx={{
                flex: 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "black",
              }}
            >
              {!is_small_screen() ? (
                <div className="feed-video mx-5">
                  <ReactVideoPlayer url={post?.video_url} playingVideo={true} />
                </div>
              ) : (
                <div className="mx-3 my-3">
                  <ReactVideoPlayer url={post?.video_url} playingVideo={true} />
                </div>
              )}
            </Box>
          )}
          {post?.feed_type === "document" && post?.media?.length > 0 && (
            <div
              className="feed-image document_img mt-3 d-flex w-100 text-center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {post.media.map((item, index) => (
                <a
                  key={index}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={s3baseUri + item}
                  className="pointer"
                  style={{
                    display: "block",
                    marginBottom: "10px",
                    color: "blue",
                  }}
                >
                  <img className="img-fluid" src={getCommentImage(item)} />{" "}
                </a>
              ))}
            </div>
          )}

          <Box
            className={
              post.feed_type == "general" || post.feed_type == "document"
                ? "mx-auto widht_contoral "
                : "bg-white"
            }
            sx={{
              marginTop: isMobile ? "40px " : "",
              position: "sticky",
              top: 0,
              zIndex: 10,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              padding: 2,
              minHeight: "100%",
              overflow: "auto !important",
              width: {
                xs:
                  post?.feed_type === "image" ||
                  post?.feed_type === "video" ||
                  post?.feed_type === "document"
                    ? "100%"
                    : "70%", // Mobile: 100% for image/video/document, 70% for other types
                sm: "500px", // No change for tablet and above
              },
            }}
          >
            <div>
              {/* <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Box display="flex" alignItems="center" width="100%">
                  <Avatar
                    onClick={handleCompanyNameClick}
                    src={
                      s3baseUri + post?.created_by?.profile_image?.thumbnail_1
                    }
                    sx={{ width: 45, height: 45, mr: 1, cursor: "pointer" }}
                  />

                  <Box
                    display="flex"
                    alignItems="start"
                    justifyContent="space-between"
                    width="100%"
                  >
                    <div>
                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        sx={{
                          fontSize: "14px",
                          cursor: "pointer",
                          "&:hover": {
                            textDecoration: "underline",
                            color: "var(--portal-primary-color)",
                          },
                        }}
                        onClick={handleCompanyNameClick}
                      >
                        {post?.created_by?.company_name}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          lineHeight: 0.6,
                          letterSpacing: "0rem !important",
                        }}
                        variant="caption"
                        color="textSecondary"
                      >
                        {handle_get_time_ago(post.published_time)}
                      </Typography>
                    </div>

                    <div className="d-flex justify-content-end">
                      {handleGetActionByStatus(post) && (
                        <span
                          key={"action-by"}
                          className="text-capitalize outlined-chip basic d-inline-block me-2 flex-shrink-0"
                        >
                          {"Action By:"}{" "}
                          {post?.action_by?.company_name ||
                            `${post?.action_by?.first_name} ${post?.action_by?.last_name}`}
                        </span>
                      )}

                      {handleMenu(post).length > 0 && (
                        <CustomPopover
                          menu={handleMenu(post)}
                          data={comments}
                        />
                      )}
                    </div>
                  </Box>
                </Box>
              </Box> */}
              <div className="d-flex align-items-center flex-nowrap">
                <Avatar
                  className="profile-img"
                  onClick={handleCompanyNameClick}
                  src={s3baseUri + post?.created_by?.profile_image?.thumbnail_1}
                />

                <div className="profile-info w-100 ps-2">
                  <div className="profile-name-top d-flex align-items-center justify-content-between">
                    <div
                      className="profile-name hover-primary"
                      onClick={handleCompanyNameClick}
                    >
                      <span>{post?.created_by?.company_name}</span>
                    </div>
                    {handleMenu(post).length > 0 && (
                      <div className="three-dots-menu">
                        <CustomPopover menu={handleMenu(post)} data={post} />
                      </div>
                    )}
                  </div>
                  <div className="sector-date-info d-flex align-items-center">
                    <span className="sector-info golden-chip">
                      {post?.source?.title || ""}
                    </span>
                    <span className="feed-date grey-text medium-text ms-2">
                      {moment(post.published_time).fromNow()}
                    </span>
                  </div>
                </div>
              </div>
              <div
                style={{
                  maxHeight:
                    isCommentAccessAllow || (isEditing && isCommentUpdateAllow)
                      ? isMobile
                        ? "84vh"
                        : "80vh"
                      : "90vh",
                  overflow: "auto",
                }}
                className="hide-scrollbar"
              >
                <div className="col-12">
                  <div
                    ref={measureRef}
                    className="feed-description"
                    style={{
                      position: "absolute",
                      visibility: "hidden",
                      whiteSpace: "pre-line",
                    }}
                  />

                  <div className="feed-description pt-3">
                    {!expanded ? (
                      <p style={{ whiteSpace: "pre-line" }}>
                        {linkify(clampedText)}
                        {needsClamp && (
                          <span
                            className="read-more-text"
                            onClick={(e) => {
                              e.stopPropagation(); // prevent navigation
                              setExpanded(true);
                            }}
                          >
                            ...more
                          </span>
                        )}
                      </p>
                    ) : (
                      <p style={{ whiteSpace: "pre-line" }}>
                        {linkify(text)}
                        <p
                          className="read-more-text"
                          onClick={(e) => {
                            e.stopPropagation(); // prevent navigation
                            setExpanded(false);
                          }}
                        >
                          ...less
                        </p>
                      </p>
                    )}
                  </div>

                  {linkInDescription &&
                    post?.is_link_preview &&
                    post.feed_type !== "image" &&
                    post.feed_type !== "document" &&
                    post.feed_type !== "video" && (
                      <div className="link-preview-section">
                        <PreviewPostCard
                          text={linkInDescription}
                          type={"icon_close"}
                          post={post}
                          state={false}
                          previewLink={previewLink}
                          setPreviewLink={setPreviewLink}
                          typeData={type}
                        />
                      </div>
                    )}
                </div>
                {(likeCount > 0 || commentCount > 0) && (
                  <div className="like-comment-count p-0 pb-2">
                    <div className="grey-text d-flex justify-content-between col-12">
                      {likeCount > 0 && (
                        <span className="like-counts d-flex align-items-center">
                          <img
                            src={liked_counts_icon}
                            alt="liked_counts_icon"
                          />
                          <span className="ms-1">{likeCount}</span>
                        </span>
                      )}

                      {commentCount > 0 && (
                        <span className="comments-count d-flex align-items-center">
                          <span>{commentCount} Comments</span>
                        </span>
                      )}
                    </div>
                  </div>
                )}

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    py: "5px",
                    borderTop: "1px solid #00000054",
                    borderBottom: "1px solid #00000054",
                  }}
                >
                  {/* Like Section */}
                  <Box
                    display="flex"
                    alignItems="center"
                    sx={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handleLike();
                    }}
                  >
                    {liked ? (
                      <button className={`like-btn grey-text`}>
                        <img
                          src={liked_icon}
                          className="engagement-icon"
                          style={{ height: 20 }}
                          alt="like_icon"
                        />
                        <span className="liked">Liked</span>
                      </button>
                    ) : (
                      <button className={`like-btn grey-text`}>
                        <img
                          src={like_icon}
                          className="engagement-icon"
                          style={{ height: 18 }}
                          alt="like_icon"
                        />
                        <span>Like</span>
                      </button>
                    )}
                  </Box>

                  {/* Comment Section */}
                  <Box
                    display="flex"
                    alignItems="center"
                    sx={{
                      cursor: !isCommentAccessAllow ? "not-allowed" : "auto",
                      opacity: !isCommentAccessAllow ? 0.5 : 1,
                    }}
                    onClick={() => {
                      if (userInfo?.role !== "candidate") {
                        // Trigger comment box or any other logic
                      }
                    }}
                  >
                    <button
                      className="comment-btn grey-text"
                      disabled={userInfo.role == "candidate"}
                    >
                      {/* <Icon icon="iconamoon:comment-bold" className="engagement-icon" /> */}
                      <img
                        src={comment_icon}
                        className="engagement-icon"
                        style={{ height: 18 }}
                        alt="comment_icon"
                      />
                      <span>Comment</span>
                    </button>
                  </Box>
                  {/* <Tooltip
                    title={
                      !post.description ? "Description required to share" : ""
                    }
                    placement="top"
                    disableHoverListener={!!post.description}
                    arrow
                  > */}
                  <span>
                    <Box
                      display="flex"
                      alignItems="center"
                      sx={{
                        cursor: "pointer",
                      }}
                    >
                      <button
                        className="share-btn grey-text"
                        onClick={() => handleShareClick(post)}
                        // disabled={!post.description}
                      >
                        <img
                          src={share_icon}
                          className="engagement-icon"
                          style={{ height: 18 }}
                          alt="share_icon"
                        />
                        <span>Share</span>
                      </button>
                    </Box>
                  </span>
                  {/* </Tooltip> */}
                </Box>

                <Box
                  sx={{
                    overflowY: "auto",
                    flex: 1,
                    mt: 2,
                    maxHeight:
                      isCommentAccessAllow ||
                      (isEditing && isCommentUpdateAllow)
                        ? expanded
                          ? "50vh"
                          : isMobile
                          ? "68vh"
                          : "60vh"
                        : "68vh",
                  }}
                  className="hide-scrollbar"
                >
                  {comments && comments.length > 0 && (
                    <Box sx={{ borderRadius: 2 }}>
                      {comments.map((comment, index) => (
                        <Box
                          key={index}
                          sx={{ borderRadius: 2, paddingBottom: "0px" }}
                          bgcolor="#FFFFFF"
                          p={1}
                          mb={1}
                          className="tw-shadow-sm tw-border tw-border-solid tw-border-slate-100 m-2"
                        >
                          <div className="poster-name-image d-flex w-100 single-comment-card">
                            <Avatar
                              src={
                                s3baseUri +
                                comment?.commented_by?.profile_image
                                  ?.thumbnail_1
                              }
                              sx={{
                                width: 40,
                                height: 40,
                                mr: 1,
                                cursor: "pointer",
                              }}
                              onClick={() => handleCommentCompanyClick(comment)}
                            >
                              {comment?.commented_by.role === "candidate"
                                ? comment?.commented_by.first_name?.charAt(0)
                                : comment?.commented_by.company_name?.charAt(0)}
                            </Avatar>
                            <div className="w-100">
                              <div
                                className="text-start set-title-width poster-name ps-1 w-100 d-flex"
                                style={{
                                  justifyContent: "space-between",
                                  display: "flex",
                                }}
                              >
                                <Typography
                                  variant="h6"
                                  fontWeight="bold"
                                  sx={{ fontSize: "14px", cursor: "pointer" }}
                                  onClick={() =>
                                    handleCommentCompanyClick(comment)
                                  }
                                >
                                  {comment?.commented_by.role === "candidate"
                                    ? `${comment?.commented_by.first_name} ${comment?.commented_by.last_name}`
                                    : comment?.commented_by.company_name}
                                </Typography>
                                <div className="popOver d-flex mt-1 align-items-center">
                                  {(comment?.action_by?.first_name ||
                                    comment?.action_by?.company_name) &&
                                    userInfo?.profile_id ===
                                      comment?.commented_by?._id &&
                                    ((!userInfo.isCompanyProfile &&
                                      userInfo?._id ===
                                        comment?.commented_by?._id) ||
                                      (userInfo.isCompanyProfile &&
                                        (userInfo?._id ==
                                          comment?.action_by?._id ||
                                          userInfo?.company_access?.feed
                                            ?.global_access))) && (
                                      <ActionByChip
                                        actionByName={
                                          comment?.action_by?.company_name ||
                                          `${comment?.action_by?.first_name} ${comment?.action_by?.last_name}`
                                        }
                                      />
                                    )}
                                  <Typography
                                    className="date-color float-end "
                                    sx={{
                                      fontSize: "12px",
                                      lineHeight: 1,
                                      marginTop: "3px",
                                    }}
                                    color="textSecondary"
                                  >
                                    {/* {moment(comment?.createdAt).format(
                                      "DD MMM YYYY [at] hh:mm A"
                                    )} */}
                                    {handle_get_time_ago(comment?.createdAt)}
                                  </Typography>
                                  {handleMenucomments(comment).length > 0 && (
                                    <CustomPopover
                                      menu={handleMenucomments(comment)}
                                      data={comment}
                                    />
                                  )}
                                </div>
                              </div>
                              <div className="post-description  ps-1">
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontSize: "14px",
                                    lineHeight: 1.5,
                                    whiteSpace: "pre-line",
                                    wordBreak: "break-word",
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: htmlDecode(comment?.text),
                                  }}
                                ></Typography>
                                {comment?.comment_image?.thumbnail_1 && (
                                  <Box>
                                    <img
                                      onClick={() =>
                                        window.open(
                                          s3baseUri +
                                            comment.comment_image?.thumbnail_1,
                                          "_blank"
                                        )
                                      }
                                      src={
                                        s3baseUri +
                                        comment.comment_image?.thumbnail_1
                                      }
                                      alt="Uploaded Comment"
                                      style={{
                                        lineHeight: "0px",
                                        height: "80px",
                                        width: "80px",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                      }}
                                      className="mt-1"
                                    />
                                  </Box>
                                )}
                                <button
                                  onClick={() =>
                                    handleLikeComment(comment, index)
                                  }
                                  style={{
                                    border: "none",
                                    background: "none",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    paddingLeft: "0px",
                                    marginTop: "5px",
                                  }}
                                >
                                  {comment.is_liked ? (
                                    <>
                                      <img
                                        src={liked_icon}
                                        className="engagement-icon"
                                        style={{ height: 16 }}
                                        alt="like_icon"
                                      />
                                      <span
                                        className="liked"
                                        style={{
                                          fontSize: "14px",
                                          color: "var(--portal-primary-color)",
                                        }}
                                      >
                                        Liked
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <img
                                        src={like_icon}
                                        className="engagement-icon"
                                        style={{ height: 16 }}
                                        alt="like_icon"
                                      />
                                      <span
                                        className="liked"
                                        style={{ fontSize: "14px" }}
                                      >
                                        Like
                                      </span>
                                    </>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              </div>
            </div>

            {(isCommentAccessAllow || (isEditing && isCommentUpdateAllow)) && (
              <form onSubmit={handleCommentSubmit} className="mt-3">
                <Box
                  display="flex"
                  alignItems="center"
                  sx={{
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  <TextField
                    fullWidth
                    label={
                      isEditing ? "Edit your comment" : "Write a comment..."
                    }
                    multiline
                    rows={2}
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                    disabled={!isCommentAccessAllow && !isCommentUpdateAllow}
                    sx={{
                      bgcolor: "white",
                      borderRadius: "5px",
                      flexGrow: 1,
                      minWidth: { xs: "100%", sm: "80%" },
                      opacity:
                        !isCommentAccessAllow && !isCommentUpdateAllow
                          ? 0.6
                          : 1,
                      cursor:
                        !isCommentAccessAllow && !isCommentUpdateAllow
                          ? "not-allowed"
                          : "text",
                      "& .MuiOutlinedInput-root": {
                        paddingTop: "5px",
                        paddingBottom: "4px",
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "4px 8px",
                      },
                    }}
                  />
                </Box>

                <Box
                  mt={1}
                  display="flex"
                  justifyContent="space-between"
                  sx={{
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  {/* File upload + preview */}
                  <div className="d-flex">
                    {!openCreateModal && (
                      <>
                        <IconButton
                          component="label"
                          disabled={
                            !isCommentAccessAllow && !isCommentUpdateAllow
                          }
                        >
                          <input
                            type="file"
                            id="imageInput"
                            style={{ display: "none" }}
                            accept="image/*"
                            onChange={handleImageUpload}
                            disabled={
                              !isCommentAccessAllow && !isCommentUpdateAllow
                            }
                          />
                          {!preview && (
                            <AddPhotoAlternateOutlinedIcon
                              sx={{
                                color: "#daa520",
                                opacity:
                                  !isCommentAccessAllow && !isCommentUpdateAllow
                                    ? 0.5
                                    : 1,
                              }}
                            />
                          )}
                        </IconButton>

                        {(preview || preview?.thumbnail_1) && (
                          <div
                            style={{
                              padding: "4px",
                              borderRadius: "5px",
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              maxWidth: "fit-content",
                              position: "relative",
                              border: "1px solid #ddd",
                              background: "#fff",
                              opacity:
                                !isCommentAccessAllow && !isCommentUpdateAllow
                                  ? 0.5
                                  : 1,
                            }}
                          >
                            <span
                              onClick={() =>
                                userInfo?.role !== "candidate" &&
                                setPreview(null)
                              }
                              style={{
                                cursor:
                                  !isCommentAccessAllow && !isCommentUpdateAllow
                                    ? "not-allowed"
                                    : "pointer",
                                background: "red",
                                color: "white",
                                borderRadius: "50%",
                                width: "15px",
                                height: "15px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "10px",
                                fontWeight: "bold",
                                position: "absolute",
                                top: "-8px",
                                right: "-8px",
                                zIndex: 2,
                                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                              }}
                            >
                              ✖
                            </span>
                            <img
                              src={
                                typeof preview === "string" &&
                                preview.startsWith("blob:")
                                  ? preview
                                  : s3baseUri + preview?.thumbnail_1
                              }
                              alt="Preview"
                              style={{
                                width: "50px",
                                height: "50px",
                                borderRadius: "5px",
                                objectFit: "cover",
                                position: "relative",
                              }}
                            />
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  {/* Emoji Picker (Optional block if type === 1) */}
                  {emojiPickerVisible &&
                    (isCommentAccessAllow || isCommentUpdateAllow) && (
                      <Box
                        sx={{
                          position: "absolute",
                          left: isMobile ? "" : "-360px",
                          bottom: "60px",
                        }}
                      >
                        <Picker data={data} onEmojiSelect={handleEmojiClick} />
                      </Box>
                    )}

                  {/* Submit Button */}
                  <div className="d-flex align-items-center justify-content-end">
                    {isEditing && (
                      <button
                        className="btn-outlined-sm me-2"
                        type="button"
                        disabled={isLoadingCom}
                        style={{
                          width: "100%",
                          maxWidth: "150px",
                          marginTop: { xs: "8px", sm: "0px" },
                          opacity: isLoadingCom ? 0.6 : 1,
                          cursor: isLoadingCom ? "not-allowed" : "pointer",
                          pointerEvents: isLoadingCom ? "none" : "auto",
                        }}
                        onClick={() => {
                          handleCancelEditComment();
                        }}
                      >
                        {"Cancel"}
                      </button>
                    )}
                    <button
                      className="btn-contained-sm"
                      type="submit"
                      disabled={
                        isLoadingCom ||
                        (!isCommentAccessAllow && !isCommentUpdateAllow)
                      }
                      style={{
                        width: "100%",
                        maxWidth: "150px",
                        marginTop: { xs: "8px", sm: "0px" },
                        opacity:
                          isLoadingCom ||
                          (!isCommentAccessAllow && !isCommentUpdateAllow)
                            ? 0.6
                            : 1,
                        cursor:
                          isLoadingCom ||
                          (!isCommentAccessAllow && !isCommentUpdateAllow)
                            ? "not-allowed"
                            : "pointer",
                        pointerEvents:
                          isLoadingCom ||
                          (!isCommentAccessAllow && !isCommentUpdateAllow)
                            ? "none"
                            : "auto",
                      }}
                    >
                      {isLoadingCom
                        ? isEditing
                          ? "Updating..."
                          : "Posting..."
                        : isEditing
                        ? "Update"
                        : "Post Comment"}
                    </button>
                  </div>
                </Box>
              </form>
            )}
          </Box>
        </Box>
      </Modal>
      {/* Company Profile Modal (shared for post creator and comment user) */}
      <CompanyPopup
        companyModalOpen={companyModalOpen}
        handleCloseCompanyModal={handleCloseCompanyModal}
        companyModalData={companyModalData}
      />
    </>
  );
};

export default PostDetailPopup;
